import { useState } from "react";
import { Rocket, Gem, Briefcase } from "lucide-react";
import { Link } from "react-router-dom";

export default function PricingSection() {
  const [billingCycle, setBillingCycle] = useState("monthly");

  const plans = [
    {
      name: "Starter",
      icon: <Rocket className="text-[#66ccff] w-6 h-6" />,
      price: billingCycle === "monthly" ? "₹499/mo" : "₹4999/yr",
      features: ["1 Project", "Basic Templates", "Community Support"],
      template: "starter",
    },
    {
      name: "Pro",
      icon: <Gem className="text-[#66ccff] w-6 h-6" />,
      price: billingCycle === "monthly" ? "₹999/mo" : "₹9999/yr",
      features: ["Unlimited Projects", "Premium Templates", "Priority Support"],
      template: "pro",
      popular: true,
    },
    {
      name: "Enterprise",
      icon: <Briefcase className="text-[#66ccff] w-6 h-6" />,
      price: billingCycle === "monthly" ? "₹1999/mo" : "₹19999/yr",
      features: ["Team Access", "Custom Templates", "Dedicated Manager"],
      template: "enterprise",
    },
  ];

  return (
    <div className="min-h-screen bg-white dark:bg-[#0a0a0a] text-black dark:text-white py-16 px-6 transition-colors duration-300">
      <h2 className="text-4xl md:text-5xl font-bold text-center text-[#0077cc] dark:text-[#66ccff] mb-6">
        Choose Your Plan
      </h2>

      {/* Billing Toggle */}
      <div className="flex justify-center mb-12 space-x-4 text-sm font-medium">
        <button
          onClick={() => setBillingCycle("monthly")}
          className={`px-4 py-2 rounded-full ${
            billingCycle === "monthly"
              ? "bg-[#0077cc] text-white"
              : "bg-gray-200 dark:bg-gray-800 text-black dark:text-white"
          } transition`}
        >
          Monthly
        </button>
        <button
          onClick={() => setBillingCycle("yearly")}
          className={`px-4 py-2 rounded-full ${
            billingCycle === "yearly"
              ? "bg-[#0077cc] text-white"
              : "bg-gray-200 dark:bg-gray-800 text-black dark:text-white"
          } transition`}
        >
          Yearly
        </button>
      </div>

      {/* Plans */}
      <div className="grid gap-10 md:grid-cols-3 max-w-6xl mx-auto">
        {plans.map((plan, index) => (
          <div
            key={index}
            className={`relative bg-gray-100 dark:bg-[#121212] border border-[#0077cc] rounded-2xl p-8 shadow-md hover:shadow-lg hover:scale-[1.03] transition-all duration-300 flex flex-col justify-between`}
          >
            {/* Most Popular Tag */}
            {plan.popular && (
              <span className="absolute -top-4 left-4 bg-gradient-to-r from-[#0077cc] to-[#66ccff] text-white text-xs font-semibold px-3 py-1 rounded-full shadow-md">
                MOST POPULAR
              </span>
            )}

            {/* Icon + Title */}
            <div className="mb-4 flex items-center gap-3">
              {plan.icon}
              <h3 className="text-2xl font-bold text-[#0077cc] dark:text-[#66ccff]">
                {plan.name}
              </h3>
            </div>

            <p className="text-3xl font-semibold text-black dark:text-white mb-6">
              {plan.price}
            </p>

            <ul className="space-y-3 text-sm text-gray-700 dark:text-gray-300 mb-8">
              {plan.features.map((feature, i) => (
                <li key={i} className="flex items-center gap-2">
                  <span className="text-[#0077cc] dark:text-[#66ccff]">✔</span>
                  {feature}
                </li>
              ))}
            </ul>

            <Link
              to={`/get-started?template=${plan.template}`}
              className="text-center py-3 rounded-full font-medium bg-gradient-to-r from-[#0077cc] to-[#66ccff] text-white hover:from-[#005fa3] hover:to-[#66ccff] transition"
            >
              Choose Plan
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
